module.exports = __webpack_public_path__ + "static/bellville-7090e16cb14a52b3b50e82ef5bc3b287.jpg";